import { render, staticRenderFns } from "./TechnicalDetails.vue?vue&type=template&id=0d3cb3fe&scoped=true"
import script from "./TechnicalDetails.vue?vue&type=script&lang=js"
export * from "./TechnicalDetails.vue?vue&type=script&lang=js"
import style0 from "./TechnicalDetails.vue?vue&type=style&index=0&id=0d3cb3fe&prod&scoped=true&lang=css"
import style1 from "./TechnicalDetails.vue?vue&type=style&index=1&id=0d3cb3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3cb3fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
